module.exports = __webpack_public_path__ + "static/img/top.f9fea43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/top.png
// module id = ve1X
// module chunks = 1